import { Routes } from '@angular/router';
import { AuthLoginComponent } from './components/auth-login/auth-login.component';
import { AuthTwoFactorsCodeComponent } from './components/auth-two-factors-code/auth-two-factors-code.component';

export const ROUTES: Routes = [
  {
    path: 'sign-in',
    component: AuthLoginComponent,
  },
  {
    path: '2fa',
    component: AuthTwoFactorsCodeComponent,
  },
];
